<template>
  <div>
    <button
      v-on:click="buttonClick"
      :disabled="disabled || (attributeIdsWithStock.length === 0 && hasAttributes)"
      class="add-to-cart-btn"
      type="button"
    >
      <span class="add-to-cart-btn-text">{{ buttonText }}</span>
      <img v-if="productData.isDigital" src="/ui/main/img/customer_account_actions_ebooks.svg" alt="Add to cart" loading="lazy" width="18" height="25" class="img-fluid add-to-cart-btn-img">
      <img v-else src="/ui/main/img/open_book_icon.svg" alt="Add to cart" loading="lazy" width="30" height="25" class="img-fluid add-to-cart-btn-img">
    </button>
    <slot></slot>
    <div v-if="!productData.isDigital" class="d-flex-100 prod-pg-shipping-info">
      <span>Δωρεάν Μεταφορικά και έξοδα αντικαταβολής από 20 €</span>
    </div>
  </div>
</template>

<script>
import store from '../../../vue/store'

export default {
  name: 'AdvProductPageButton',
  props: {
    productId: Number,
    quantity: Number,
    disabled: {
      type: Boolean,
      default: false
    },
    isListing: {
      type: Boolean,
      default: false
    },
    isVariationGroupMaster: {
      type: Boolean,
      default: false
    },
    attributeIdsWithStock: {
      type: Array,
      default: () => []
    },
    buttonText: {
      type: String,
      default: ''
    },
    cartQuantity: {
      type: Number,
      default: 0
    },
  },
  data () {
    return {
      version: '0.0.1'
    }
  },
  computed: {
    productData () {
      return store.getters.getProductById(this.productId)
    },
    hasAttributes () {
      return this.productData.productCodes.length > 1
    }
  },
  methods: {
    buttonClick () {
      this.$emit('btn-click')
      const productPrice = this.productData.productFinalPrice
      const barcode = this.productData.barCodes[0]
      const productQuantity = this.quantity

      const pixieEventOptions = {
        value: productPrice,
        currency: 'EUR',
        OrderID: barcode,
        Quantity: productQuantity
      }

      const taboolaEventOptions = {
        notify: 'event',
        name: 'add_to_cart',
        revenue: productPrice,
        orderid: barcode,
        currency: 'EUR',
        quantity: productQuantity
      }

      document.dispatchEvent(new CustomEvent('pixieAddToCart', {
        detail: {
          data: pixieEventOptions
        }
      }))

      document.dispatchEvent(new CustomEvent('taboolaAddToCart', {
        detail: {
          data: taboolaEventOptions
        }
      }))
    }
  }
}
</script>

<style lang="scss" scoped>
.add-to-cart-btn {
  display: flex;
  gap: 15px;
  align-items: center;
  background-color: #231F20;
  justify-content: center;
  // padding: 10px;
  height:56px;
  &[disabled]{
    background: #F2F2F2;
    pointer-events: none;
    .add-to-cart-btn-text{
      color:#989898;
    }
    .add-to-cart-btn-img{
      display: none
    }
    &:hover{
      background: #F2F2F2;
      .add-to-cart-btn-text{
        color:#989898;
      }
    }
  }
}
.add-to-cart-btn-text {
  color: #fff;
  font-size: 24px;
  font-weight: 700;
  @media screen and (max-width:1199px){
    font-size: 17px;
  }
}
.add-to-cart-btn-img {
  filter: brightness(0) invert(1) saturate(0);
  @media screen and (max-width:1199px){
    display: none;
  }
}
</style>
